import _ from "lodash";
import React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import * as Forms from "../../../../forms";

interface OwnProps {
    formComponent: Comp.Validation.IComponentWithValidatedForm;
    label?: string;
    name: string;
}

interface OwnState {
}

export class ExperienceEditor extends React.Component<OwnProps, OwnState> {
    public render() {
        const modelItems = this.props.formComponent.getFormModel<Forms.CareerCenter.PostResumeData>().data.experience;

        // Build link editors
        const sortedItems = _.orderBy(modelItems, "index");
        const items = sortedItems.map((item, i) => {

            return <li key={i} className="list-builder-item" style={{ display: item.isDelete ? "none" : "block" }}>
                <div className="list-builder-fields">
                    <Comp.Editors.TextField
                        formComponent={this.props.formComponent}
                        name={this.props.name + `[${i}].organization`}
                        placeholder="Company/institution name"
                    />

                    <Comp.Editors.TextField
                        formComponent={this.props.formComponent}
                        name={this.props.name + `[${i}].position`}
                        placeholder="Title"
                    />
                </div>
                <BS.Button bsStyle="danger" className="remove-trigger" onClick={() => this.onDelete(item.index)} title="Delete experience">
                    <i className="fa fa-times"></i>
                </BS.Button>
            </li>;
        });

        return <div>
            <Comp.Editors.FormField label="" name={this.props.name} noFieldWrap>
                <ul className="list-builder">
                    {items}
                </ul>
            </Comp.Editors.FormField>

            <Comp.Editors.FormField name="">
                <BS.ButtonGroup>
                    <BS.Button onClick={() => this.onAdd()}><i className="fa fa-plus"></i> Add experience</BS.Button>
                </BS.ButtonGroup>
            </Comp.Editors.FormField>
        </div>;
    }

    private onAdd() {
        const formModel = this.props.formComponent.getFormModel<Forms.CareerCenter.PostResumeData>();
        formModel.data.experience.push({
            ...Forms.CareerCenter.DefaultPostResumeObjects.Experience(),
            index: formModel.data.experience.length,
        });
        this.props.formComponent.updateFormModel(formModel);
    }

    private onDelete(slideIdx: number) {
        const formModel = this.props.formComponent.getFormModel<Forms.CareerCenter.PostResumeData>();
        const item = _.find(formModel.data.experience, (s, i) => s.index === slideIdx);

        if (item)
            item.isDelete = true;

        this.props.formComponent.updateFormModel(formModel);
    }
}



// WEBPACK FOOTER //
// ./src/containers/careerCenter/postResume/components/ExperienceEditor.tsx